exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: #c6c6c6;\r\n    width: 400px;\r\n    margin-bottom: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\nul {\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0; \r\n}\r\n\r\nli {\r\n    display: inline;\r\n    flex-grow: 1;\r\n    height: 80px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/menu/menu.component.css
// module id = 2130
// module chunks = 1